import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ModulePageContainer from 'views/modules/ModulePageContainer';
import ModuleArchiveContainer from 'views/modules/ModuleArchiveContainer';
import ModuleFinderContainer from 'views/modules/ModuleFinderContainer';
import NotFoundPage from 'views/errors/NotFoundPage';
import ExternalRedirect from './ExternalRedirect';

// IMPORTANT: Remember to update any route changes on the sitemap
const Routes: React.FC = () => (
  <Switch>
    <Redirect exact from="/" to="/courses" />
    <Route exact path="/courses" component={ModuleFinderContainer} />
    <Route path="/courses/:moduleCode/:slug?" component={ModulePageContainer} />
    {/* Legacy Routes: Consider removal in the future, but otherwise */}
    {/* redirecting old hyperlinks to the same page makes sense as well. */}
    <Route exact path="/modules" component={ModuleFinderContainer} />
    <Route path="/modules/:moduleCode/:slug?" component={ModulePageContainer} />
    {/* END LEGACY ROUTES */}
    <Route path="/archive/:moduleCode/:year/:slug?" component={ModuleArchiveContainer} />

    <Redirect from="/today" to="/courses" />
    <Redirect from="/timetable" to="/courses" />
    <Redirect from="/optimiser" to="/courses" />
    <Redirect from="/venues" to="/courses" />
    <Redirect from="/planner" to="/courses" />
    <Redirect from="/cpex" to="/courses" />
    <Redirect from="/tetris" to="/courses" />
    <Redirect from="/about" to="/courses" />
    <Redirect from="/faq" to="/courses" />
    <Redirect from="/settings" to="/courses" />
    <Redirect from="/contribute" to="/courses" />
    <Redirect from="/team" to="/courses" />
    <Redirect from="/contributors" to="/courses" />
    <Redirect from="/apps" to="/courses" />

    {/* v2 routes */}
    <Redirect from="/venueavailability" to="/courses" />
    <Redirect from="/contribute/developers" to="/courses" />
    <Redirect from="/contact" to="/courses" />
    <Redirect from="/help" to="/courses" />
    <ExternalRedirect path="/news/nusdiscount" to="https://www.facebook.com/nusdiscount/" />
    <ExternalRedirect path="/news/bareNUS" to="https://www.facebook.com/bareNUS" />
    <ExternalRedirect path="/api" to="https://api.nusmods.com" appendPath />

    {/* 404 page */}
    <Route component={NotFoundPage} />
  </Switch>
);

export default Routes;
